import React, { useState } from 'react';

import { Button } from '../../../components';
import { OuterContainer, SectionTitle, TextInput } from '../styles';
import { Table, TableBody, Td, Tr, Th, Input, FlexContainer, ErrorText } from './styles';

export const Skills = ({ skills, updateConfig }) => {
  const [skillsArray, setSkillsArray] = useState(JSON.parse(JSON.stringify(skills.value)));
  const [showAddSkill, setShowAddSkill] = useState(false);
  const [newSkill, setNewSkill] = useState('');
  const [newSkillColor, setNewSkillColor] = useState('');
  const [error, setError] = useState('');

  const updateSkillColor = (index, color) => {
    let skillsArrayCopy = JSON.parse(JSON.stringify(skillsArray));
    skillsArrayCopy[index].tagColor = color;
    setSkillsArray(skillsArrayCopy);
  };

  const renderNameAndSkillColor = () =>
    skillsArray.map((skill, index) => (
      <Tr key={index}>
        <Td>{skill.name}</Td>
        <Td>
          <Input type="color" value={skill.tagColor} onChange={(e) => updateSkillColor(index, e.target.value)} />
        </Td>
      </Tr>
    ));

  const updateSkillTag = () => {
    if (showAddSkill) {
      if (!newSkill.trim() || !newSkillColor.trim()) return setError('Name and color is required');
      let skillsArrayCopy = JSON.parse(JSON.stringify(skillsArray));
      skillsArrayCopy.push({ name: newSkill, tagColor: newSkillColor });
      setSkillsArray(skillsArrayCopy);
      updateConfig(skills._id, { value: skillsArrayCopy });
    } else {
      updateConfig(skills._id, { value: skillsArray });
    }
    setShowAddSkill(false);
    setNewSkillColor('');
    setNewSkill('');
    setError('');
  };

  return (
    <OuterContainer>
      <SectionTitle>Skills</SectionTitle>
      <Table>
        <TableBody>
          <Tr>
            <Th>Skills</Th>
            <Th>Color</Th>
          </Tr>
          {renderNameAndSkillColor()}
          {showAddSkill && (
            <Tr>
              <Td>
                <TextInput type="text" value={newSkill} onChange={(e) => setNewSkill(e.target.value)} />
              </Td>
              <Td>
                <Input type="color" value={newSkillColor} onChange={(e) => setNewSkillColor(e.target.value)} />
              </Td>
            </Tr>
          )}
        </TableBody>
      </Table>
      {error && <ErrorText marginTop="0px">{error}</ErrorText>}
      <FlexContainer>
        <Button
          small
          primaryBlue
          primaryGreenBorder
          removeMargin
          margin="15px 0 0 0px"
          onClick={() => {
            if (showAddSkill) setError('');
            setShowAddSkill(!showAddSkill);
          }}
        >
          Add
        </Button>
        <Button
          small
          primaryBlue
          primaryGreenBorder
          removeMargin
          margin="15px 0 0 15px"
          onClick={() => updateSkillTag()}
        >
          Save
        </Button>
      </FlexContainer>
    </OuterContainer>
  );
};
